import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FileUploader } from "react-drag-drop-files";
import { Form, Button } from "react-bootstrap";
import { Indianlanguages } from "../assets/Json/laanlist";
import Translator from "../translator";
import CorouselExample from "./imageCorousel";

function ImageOCR() {
  const [files, SetFiles] = useState();

  const handleChange = async (file) => {
    SetFiles(file);
  };

  const handleUpload = async (file) => {
    SetFiles(file);
  };

  const selectlang = (value) => {
    localStorage.setItem("lang", value);
  };

  return (
    <>
      <div className="banner-allpage-sec">
        <ul className="breadcrumb">
          <li>
            <a href="https://anuvadini.aicte-india.org/">Home</a>
          </li>
          <li>
            <Link to="/JaduiDarpan/">Anuvadini-Image23</Link>
          </li>
        </ul>
        <CorouselExample />
        <div className="banner-content-sec text-center">
          <br />
          <h1 className="first-head">JaduiDarpan</h1>
          <h3 className="second-head">
            Translate photos into 30+ Languages In Seconds, whether they are
            posters, brochures, screenshots, advertisements, product images
          </h3>
          <br />
        </div>
      </div>
      <section
        style={{
          textAlign: "center",
          marginTop: -50,
          position: "relative",
          overflow: "hidden",
        }}
      >
        <div className="container-fluid">
          <Translator />
        </div>
      </section>

      {/* <div className="page-container logo-maker-page">
        <h2 className="text-center">SMARTER. FASTER. EASIER.</h2>
        <br />
        <br />
        <br />
        <div className="row text-center sfe-sec">
          <div className="col-lg-4">
            <div className="box">
              <svg
                stroke="currentColor"
                fill="currentColor"
                strokeWidth="0"
                viewBox="0 0 512 512"
                focusable="false"
                className="chakra-icon css-wk6432"
                height="4em"
                width="4em"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill="none"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="32"
                  d="M83 384c-13-33-35-93.37-35-128C48 141.12 149.33 48 256 48s208 93.12 208 208c0 34.63-23 97-35 128"
                ></path>
                <path
                  fill="none"
                  stroke-miterlimit="10"
                  strokeWidth="32"
                  d="M108.39 270.13l-13.69 8h0c-30.23 17.7-31.7 72.41-3.38 122.2s75.87 75.81 106.1 58.12h0l13.69-8a16.16 16.16 0 005.78-21.87L130 276a15.74 15.74 0 00-21.61-5.87zm295.22 0l13.69 8h0c30.23 17.69 31.74 72.4 3.38 122.19s-75.87 75.81-106.1 58.12h0l-13.69-8a16.16 16.16 0 01-5.78-21.87L382 276a15.74 15.74 0 0121.61-5.87z"
                ></path>
              </svg>
              <h3>Online stereo enhancer</h3>
              <p>
                This tool allows you to create a 3D audio version of any song
                directly in your browser. 3D versions of songs are popular on
                YouTube and with this tool you can create that 3D effect without
                having to download any annoying software.
              </p>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="box">
              <svg
                stroke="currentColor"
                fill="currentColor"
                strokeWidth="0"
                viewBox="0 0 512 512"
                focusable="false"
                className="chakra-icon css-wk6432"
                height="4em"
                width="4em"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill="none"
                  stroke-miterlimit="10"
                  strokeWidth="32"
                  d="M256 80a176 176 0 10176 176A176 176 0 00256 80z"
                ></path>
                <path
                  fill="none"
                  strokeLinecap="round"
                  stroke-miterlimit="10"
                  strokeWidth="28"
                  d="M200 202.29s.84-17.5 19.57-32.57C230.68 160.77 244 158.18 256 158c10.93-.14 20.69 1.67 26.53 4.45 10 4.76 29.47 16.38 29.47 41.09 0 26-17 37.81-36.37 50.8S251 281.43 251 296"
                ></path>
                <circle cx="250" cy="348" r="20"></circle>
              </svg>
              <h3>How is it done?</h3>
              <p>
                This tool will add a very small delay to one channel which
                creates a small but noticeable effect. It creates the illusion
                that the song is playing live in front of you. This effect is
                only effective if you're listening with headphones.
              </p>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="box">
              <svg
                stroke="currentColor"
                fill="currentColor"
                strokeWidth="0"
                viewBox="0 0 512 512"
                focusable="false"
                className="chakra-icon css-wk6432"
                height="4em"
                width="4em"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill="none"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="32"
                  d="M304 48l112 112-112 112m94.87-112H96m112 304L96 352l112-112m-94 112h302"
                ></path>
              </svg>
              <h3>Example of usage</h3>
              <p>
                Here is a before and after example of a short audio file that
                has been processed using this tool.
              </p>
            </div>
          </div>
        </div>
      </div> */}
    </>
  );
}

export default ImageOCR;
